// steps
export const STEP_INITIAL = 'initial';
export const STEP_4_YEAR = 'four-year';
export const STEP_CC = 'community-college';
export const STEP_OTHER = 'other';
export const STEP_UNDECIDED = 'undecided';
export const STEP_COMPLETE = 'completed';
export const STEP_OTHER_EMAIL = 'other-email';
export const STEP_4_YEAR_SURVEY = 'four-year-survey';
export const STEP_UNDECIDED_SURVEY = 'undecided-survey';
export const STEP_OTHER_SURVEY = 'other-survey';

// routes
export const PORTFOLIO_ROUTE = '/portfolio';
export const NEXT_STEPS_INITIAL_ROUTE = '/next-steps';
export const NEXT_STEPS_CC_ROUTE = `/${STEP_CC}`;
export const NEXT_STEPS_OTHER_ROUTE = `/${STEP_OTHER}`;
export const NEXT_STEPS_OTHER_EMAIL_ROUTE = `/${STEP_OTHER_EMAIL}`;
export const NEXT_STEPS_OTHER_SURVEY_ROUTE = `/${STEP_OTHER_SURVEY}`;
export const NEXT_STEPS_FOUR_YEAR_ROUTE = `/${STEP_4_YEAR}`;
export const NEXT_STEPS_FOUR_YEAR_SURVEY_ROUTE = `/${STEP_4_YEAR_SURVEY}`;
export const NEXT_STEPS_UNDECIDED_ROUTE = `/${STEP_UNDECIDED}`;
export const NEXT_STEPS_UNDECIDED_SURVEY_ROUTE = `/${STEP_UNDECIDED_SURVEY}`;
export const NEXT_STEPS_COMPLETE_ROUTE = `/portfolio/next-steps/${STEP_COMPLETE}`;
export const INTERACTION_NAME = 'account-conversion-next-steps';

export const OTHER_OPTIONS = [
  {
    value: 'vocational-school',
    label: 'Career and technical education (CTE) or vocational school',
  },
  {value: 'military-service', label: 'Military service'},
  {value: 'travel', label: 'Travel'},
  {value: 'work', label: 'Work'},
  {value: 'other', label: 'Other'},
];

export const PLANNING_OPTIONS = [
  {text: 'Already started', value: 'already-started', _id: 'already-started'},
  {text: 'In the next 0-6 months', value: 'next-0-6-months', _id: 'next-0-6-months'},
  {text: 'In the next 6-12 months', value: 'next-6-12-months', _id: 'next-6-12-months'},
  {text: 'In the next 1-2 years', value: 'next-1-2-years', _id: 'next-1-2-years'},
  {text: 'Still deciding', value: 'still-deciding', _id: 'still-deciding'},
];

// banners
export const BANNER_MESSAGES = {
  [STEP_INITIAL]: {
    message: "🎓 What's next in your education?",
    link: 'Answer',
    linkPath: PORTFOLIO_ROUTE + NEXT_STEPS_INITIAL_ROUTE,
  },
  [STEP_CC]: {
    message:
      '🎓 Attending community college after high school? Learn about converting your account.',
    link: 'Learn More',
    linkPath: PORTFOLIO_ROUTE + NEXT_STEPS_INITIAL_ROUTE + NEXT_STEPS_CC_ROUTE,
  },
  [STEP_UNDECIDED]: {
    message: '🎓 Let us know when you have decided what’s next in your education',
    link: 'Answer',
    linkPath: PORTFOLIO_ROUTE + NEXT_STEPS_INITIAL_ROUTE,
  },
  [STEP_OTHER]: {
    message: '🎓 Let us know what other plans you have after high school.',
    link: 'Answer',
    linkPath: PORTFOLIO_ROUTE + NEXT_STEPS_INITIAL_ROUTE + NEXT_STEPS_OTHER_ROUTE,
  },
  [STEP_4_YEAR]: {
    message:
      '🎓 Attending a 4-year college? Get updates on special scholarship opportunities in the future.',
    link: 'Update Profile',
    linkPath: PORTFOLIO_ROUTE + NEXT_STEPS_INITIAL_ROUTE + NEXT_STEPS_FOUR_YEAR_ROUTE,
  },
};
